"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bobbio": {
    "5939586b": [{
      "hkey": "071f7080",
      "slug": "santa-maria",
      "name": "Santa Maria",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria-san-cristoforo": [{
      "hkey": "071f7080",
      "slug": "santa-maria",
      "name": "Santa Maria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "888e9e1a": [{
      "hkey": "a97bff05",
      "slug": "cassolo-cavarelli",
      "name": "Cassolo-Cavarelli",
      "primary": true,
      "skipSearch": false
    }],
    "cassolo": [{
      "hkey": "a97bff05",
      "slug": "cassolo-cavarelli",
      "name": "Cassolo-Cavarelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c146e8c7": [{
      "hkey": "4a32a283",
      "slug": "bobbio",
      "name": "Bobbio",
      "primary": true,
      "skipSearch": false
    }],
    "dezza": [{
      "hkey": "4a32a283",
      "slug": "bobbio",
      "name": "Bobbio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;